import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

const message = {
  signup: 'Email already exists. Please use a different email address.',
  blacklist: 'Please register using a business email address.',
  other: '<strong>Uh oh!</strong> Something went wrong. Please try again later.',
}

const getErrorMarkup = (type) => {
  return _.get(message, type)
}

const createMarkup = (html) => ({
  __html: html,
})

const createErrorMarkup = (type) => _.flow(getErrorMarkup, createMarkup)(type)

const ErrorMessage = ({ type }) => {
  return (
    <div>
      <div
        className="ui error message"
        style={{ margin: '1.5em 0', textAlign: 'left' }}
        dangerouslySetInnerHTML={createErrorMarkup(type)}
      />
    </div>
  )
}

ErrorMessage.propTypes = {
  type: PropTypes.string,
}

export default ErrorMessage



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/containers/AccountCompletionForm/Error/index.js